import { Outlet, Link, useLocation } from "react-router-dom";
import { AppContext } from "../App";
import { useContext, useEffect } from "react";
import Label from "./Label";
import Footer from "./Footer";
import { getCmsPagePath, setCookie } from "./functions";
import LoginPopup from "../pages/LoginPopup";
import Cookies from "./Cookies";
import CmsMenu from "./CmsMenu";
import ChengeIcon from "./icons/ChengeIcon";
import LangSelector from "./LangSelector";
import UserIcon from "./icons/UserIcon";
import HamburgerIcon from "./icons/HamburgerIcon";
import CloseIcon from "./icons/CloseIcon";

function Layout() {
	const {
		settings,
		pages,
		getTranslatedString,
		user,
		loginPopup,
		track,
		menus,
		setBrand,
		mainSettings,
		hasOrders,
		hasReservations,
		cart,
		setLoginRedirect,
		loadRelated,
		getRelatedProducts,
		setRelatedProducts,
		openBrandSelectionPopup,
		brandSelectionAtOrderInit,
		forceMainBrandNavigation,
		navigateViaMaster,
		brand,
		hotel,
		hotelBrandSelectionRequired,
		hotelAvailableBrands,
		masterFooterMenus,
		masterFooterPages,
		masterFooterLoaded,
	} = useContext(AppContext);
	const location = useLocation();
	const selectBrandOnOrderInit = hotel
		? hotelBrandSelectionRequired || hotelAvailableBrands.length > 1
		: brandSelectionAtOrderInit && mainSettings?.mandant?.childs?.length > 0;
	const orderPath = "/store";
	const headerSettings = forceMainBrandNavigation ? mainSettings || settings : settings;
	const headerMenus = !forceMainBrandNavigation
		? menus
		: brand == "main"
			? menus
			: masterFooterLoaded
				? masterFooterMenus
				: [];
	const headerPages = !forceMainBrandNavigation
		? pages
		: brand == "main"
			? pages
			: masterFooterLoaded
				? masterFooterPages
				: [];
	const isUserSectionPath = (target) => {
		if (!target) return false;
		const userSectionPaths = [
			"/login",
			"/userboard",
			"/orders",
			"/bookings",
			"/billing_address",
			"/points_transactions",
			"/credits_transactions",
			"/check_email",
			"/email_login",
			"/check_mobile",
			"/signup_mobile",
			"/check_code_mobile",
			"/mobile_login",
			"/check_hotel",
			"/check_code_hotel",
			"/check_password_code_sms",
			"/signup",
			"/check_code",
			"/check_password_code",
			"/new_password",
		];
		return (
			userSectionPaths.some((path) => target === path || target.startsWith(path + "/")) ||
			target.startsWith("/password/new/")
		);
	};

	const goToMasterHomeIfEnabled = () => {
		if (selectBrandOnOrderInit) setBrand("main");
	};

	useEffect(() => {
		console.log("related", location);
		if (
			settings.menu_api?.enable_related_products_on_checkout == 1 &&
			location.pathname === "/checkout"
		) {
			if (loadRelated) getRelatedProducts(getCartProductsIds());
			else setRelatedProducts(false);
		}
	}, [location]);

	const swapMenu = () => {
		const el = document.getElementById("menu");
		if (el.classList.contains("visible")) hideMenu();
		else showMenu();
	};

	const showMenu = () => {
		const el = document.getElementById("menu");
		el.classList.add("visible");
	};

	const hideMenu = () => {
		const el = document.getElementById("menu");
		el.classList.remove("visible");
	};

	const getCartProductsIds = () => {
		let res = [];
		for (const product of cart.products) {
			res.push(product.product_id);
		}
		return res;
	};

	const sidebarNavigate = (e, target) => {
		hideMenu();
		track();
		if (!forceMainBrandNavigation || isUserSectionPath(target)) return;
		e.preventDefault();
		navigateViaMaster(target);
	};

	const headerNavigate = (e, target) => {
		track();
		if (!forceMainBrandNavigation || isUserSectionPath(target)) return;
		e.preventDefault();
		navigateViaMaster(target);
	};

	return (
		<>
			<div id="header" className="screen-container">
				<div className="header-left">
					{!forceMainBrandNavigation && !selectBrandOnOrderInit && headerSettings.website.url_logo ? (
						<a href={headerSettings.website.url_logo} className="logo">
							{headerSettings.website.logo ? (
								<img src={headerSettings.website.logo} />
							) : (
								headerSettings.global.name
							)}
						</a>
					) : (
						<Link
							to="/"
							className="logo"
							onClick={(e) => {
								goToMasterHomeIfEnabled();
								headerNavigate(e, "/");
							}}
						>
							{headerSettings.website.logo ? (
								<img src={headerSettings.website.logo} />
							) : (
								headerSettings.global.name
							)}
						</Link>
					)}
					{mainSettings?.mandant?.childs?.length > 0 && !brandSelectionAtOrderInit && (
						<button
							className="brands-switch"
							onClick={() => {
								setBrand(false);
								setCookie("website-brand", "", -1);
							}}
						>
							<ChengeIcon />
						</button>
					)}
				</div>

				<div className="menu">
					{headerMenus.filter((m) => m.section == "header").length > 0 ? (
						<>
							{headerMenus.map(
								(menu, i) =>
									menu.section == "header" && (
										<CmsMenu
											data={menu}
											key={i}
											type="bubble"
											onInternalNavigate={(target) => navigateViaMaster(target)}
										/>
									)
							)}
						</>
					) : (
						<>
							{hasOrders && (
								<Link
									className="button button-primary hidden-small"
									to={orderPath}
									onClick={(e) => {
										if (selectBrandOnOrderInit) {
											e.preventDefault();
											openBrandSelectionPopup("/store", "order-button");
										} else if (forceMainBrandNavigation) {
											e.preventDefault();
											navigateViaMaster("/store");
										}
										track();
									}}
								>
									<Label number={1} />
								</Link>
							)}
							{hasReservations == 1 && (
								<Link
									className="button button-primary hidden-small"
									to="/booking"
									onClick={(e) => headerNavigate(e, "/booking")}
								>
									<Label number={2} />
								</Link>
							)}
						</>
					)}

					{!user ? (
						<Link
							className="button button-icon"
							to="/login"
							onClick={(e) => {
								hideMenu();
								headerNavigate(e, "/login");
								setLoginRedirect(location.pathname);
							}}
						>
							<UserIcon></UserIcon>
							<div className="hidden-small">
								<Label number={3} />
							</div>
						</Link>
					) : (
						<Link
							className="button button-icon"
							to="/userboard"
							onClick={(e) => {
								hideMenu();
								headerNavigate(e, "/userboard");
							}}
						>
							<UserIcon></UserIcon>
							<div className="account-button hidden-small">{user.name}</div>
						</Link>
					)}

					<button onClick={swapMenu} className="button button-icon menu-button">
						<HamburgerIcon></HamburgerIcon>
					</button>
					<LangSelector />
				</div>
			</div>

			<div id="main">
				<Outlet />
				<Footer />
			</div>

			<div id="menu">
				<div className="container">
					<div className="header">
						<button onClick={swapMenu}>
							<CloseIcon></CloseIcon>
						</button>
					</div>
					<div className="content">
						{headerMenus.filter((m) => m.section == "main").length > 0 ? (
							<>
								{headerMenus.map(
									(menu, i) =>
										menu.section == "main" && (
											<CmsMenu
												data={menu}
												key={i}
												type="accordion"
												onInternalNavigate={(target) => navigateViaMaster(target)}
											/>
										)
								)}
							</>
						) : (
							<>
								{hasOrders && (
									<Link
										className="button button-primary hidden-large"
										to={orderPath}
										onClick={(e) => {
											hideMenu();
											if (selectBrandOnOrderInit) {
												e.preventDefault();
												openBrandSelectionPopup("/store", "order-button");
											} else if (forceMainBrandNavigation) {
												e.preventDefault();
												navigateViaMaster("/store");
											}
											track();
										}}
									>
										<Label number={1} />
									</Link>
								)}
								{hasReservations && (
									<Link
										className="button button-primary hidden-large"
										to="/booking"
										onClick={(e) => sidebarNavigate(e, "/booking")}
									>
										<Label number={2} />
									</Link>
								)}
								<Link
									className="button"
									to="/shops"
									onClick={(e) => sidebarNavigate(e, "/shops")}
								>
									<Label number={29} />
								</Link>
								{headerSettings.website.news == 1 && (
									<Link
										className="button"
										to="/news"
										onClick={(e) => sidebarNavigate(e, "/news")}
									>
										<Label number={177} />
									</Link>
								)}
								<Link
									className="button"
									to="/promo"
									onClick={(e) => sidebarNavigate(e, "/promo")}
								>
									<Label number={157} />
								</Link>
								{headerPages.map(
									(page, i) =>
										page.menu_header == 1 && (
											<Link
												key={i}
												className="button"
												to={getCmsPagePath(page)}
												onClick={(e) => sidebarNavigate(e, getCmsPagePath(page))}
											>
												{getTranslatedString(page, "title")}
											</Link>
										)
								)}
							</>
						)}
					</div>
					{headerSettings.mandant.multilanguage == 1 && (
						<div className="footer">
							<div className="info">
								{headerSettings.global.company && (
									<div className="title">{headerSettings.global.company}</div>
								)}
								{headerSettings.global.vat && <div>P.Iva {headerSettings.global.vat}</div>}
								{headerSettings.global.taxcode && (
									<div>C.F. {headerSettings.global.taxcode}</div>
								)}
								{headerSettings.global.capital && (
									<div>Capitale Sociale: {headerSettings.global.capital}</div>
								)}
								{headerSettings.global.rea && (
									<div>Numero REA: {headerSettings.global.rea}</div>
								)}
								{headerPages.map(
									(page, i) =>
										page.menu_footer == 1 && (
											<div key={i}>
												<Link
													key={i}
													className=""
													to={getCmsPagePath(page)}
													onClick={(e) => {
														if (!forceMainBrandNavigation) return;
														e.preventDefault();
														navigateViaMaster(getCmsPagePath(page));
													}}
												>
													{page.title}
												</Link>
											</div>
										)
								)}
								<div>
									<a href="https://www.yellgo.it" target="_blank">
										Powered by YellGO
									</a>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>

			{loginPopup && <LoginPopup />}
			{settings && settings.website.disable_cookies_banner != 1 && <Cookies />}
			{settings && settings.mandant.expired && (
				<div className="expire">
					<div className="content">
						<h3>ATTENZIONE</h3>
						Servizio non attivo
					</div>
				</div>
			)}
		</>
	);
}

export default Layout;
